export default {
  MX: '+52',
  CL: '+56',
  PE: '+51',
  CO: '+57',
  EC: '+593',
  CR: '+506'
}
